var _mask, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTearSheetHoveredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1966_9964",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4421 6.88628V18.6H1.4V1.4H10.4204L10.5939 1.57855L10.8935 6.23939C10.8998 6.33665 10.9752 6.41524 11.0722 6.42546L15.4421 6.88628ZM16.8421 18.6667V6.552C16.842 6.19862 16.7057 5.85973 16.4629 5.60978L11.3913 0.390222C11.1484 0.140428 10.8191 7.54501e-05 10.4758 0H1.29555C0.951946 0 0.622419 0.140476 0.379457 0.390524C0.136495 0.640573 0 0.979711 0 1.33333V18.6667C0 19.0203 0.136495 19.3594 0.379457 19.6095C0.622419 19.8595 0.951946 20 1.29555 20H15.5466C15.8902 20 16.2197 19.8595 16.4626 19.6095C16.7056 19.3594 16.8421 19.0203 16.8421 18.6667Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4421 6.88628V18.6H1.4V1.4H10.4204L10.5939 1.57855L10.8935 6.23939C10.8998 6.33665 10.9752 6.41524 11.0722 6.42546L15.4421 6.88628ZM16.8421 18.6667V6.552C16.842 6.19862 16.7057 5.85973 16.4629 5.60978L11.3913 0.390222C11.1484 0.140428 10.8191 7.54501e-05 10.4758 0H1.29555C0.951946 0 0.622419 0.140476 0.379457 0.390524C0.136495 0.640573 0 0.979711 0 1.33333V18.6667C0 19.0203 0.136495 19.3594 0.379457 19.6095C0.622419 19.8595 0.951946 20 1.29555 20H15.5466C15.8902 20 16.2197 19.8595 16.4626 19.6095C16.7056 19.3594 16.8421 19.0203 16.8421 18.6667Z",
    fill: "url(#paint0_linear_1966_9964)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4421 18.6V19.6H16.4421V18.6H15.4421ZM15.4421 6.88628H16.4421V5.98619L15.547 5.8918L15.4421 6.88628ZM1.4 18.6H0.4V19.6H1.4V18.6ZM1.4 1.4V0.4H0.4V1.4H1.4ZM10.4204 1.4L11.1376 0.70313L10.8431 0.4H10.4204V1.4ZM10.5939 1.57855L11.5919 1.51439L11.5682 1.14625L11.3111 0.881677L10.5939 1.57855ZM10.8935 6.23939L11.8915 6.17524V6.17524L10.8935 6.23939ZM11.0722 6.42546L10.9673 7.41995H10.9673L11.0722 6.42546ZM16.8421 6.552H17.8421V6.55179L16.8421 6.552ZM16.4629 5.60978L17.1804 4.91313L17.1801 4.91291L16.4629 5.60978ZM11.3913 0.390222L12.1085 -0.306649L12.1083 -0.306878L11.3913 0.390222ZM10.4758 0L10.476 -1H10.4758V0ZM0.379457 0.390524L1.09665 1.0874L1.09665 1.0874L0.379457 0.390524ZM0.379457 19.6095L1.09665 18.9126L1.09665 18.9126L0.379457 19.6095ZM16.4626 19.6095L15.7455 18.9126L15.7455 18.9126L16.4626 19.6095ZM16.4421 18.6V6.88628H14.4421V18.6H16.4421ZM1.4 19.6H15.4421V17.6H1.4V19.6ZM0.4 1.4V18.6H2.4V1.4H0.4ZM10.4204 0.4H1.4V2.4H10.4204V0.4ZM11.3111 0.881677L11.1376 0.70313L9.70323 2.09687L9.87671 2.27542L11.3111 0.881677ZM11.8915 6.17524L11.5919 1.51439L9.59597 1.6427L9.89561 6.30355L11.8915 6.17524ZM11.177 5.43097C11.5647 5.47186 11.8665 5.78621 11.8915 6.17524L9.89561 6.30355C9.93312 6.88709 10.3858 7.35862 10.9673 7.41995L11.177 5.43097ZM15.547 5.8918L11.177 5.43097L10.9673 7.41995L15.3372 7.88077L15.547 5.8918ZM15.8421 6.552V18.6667H17.8421V6.552H15.8421ZM15.7455 6.30642C15.8042 6.36685 15.8421 6.45474 15.8421 6.55221L17.8421 6.55179C17.842 5.94251 17.6071 5.35261 17.1804 4.91313L15.7455 6.30642ZM10.6741 1.08709L15.7457 6.30665L17.1801 4.91291L12.1085 -0.306649L10.6741 1.08709ZM10.4756 1C10.5445 1.00002 10.6166 1.02792 10.6743 1.08732L12.1083 -0.306878C11.6803 -0.74706 11.0938 -0.999864 10.476 -1L10.4756 1ZM1.29555 1H10.4758V-1H1.29555V1ZM1.09665 1.0874C1.15444 1.02792 1.22659 1 1.29555 1V-1C0.677302 -1 0.0903977 -0.746971 -0.33774 -0.306347L1.09665 1.0874ZM1 1.33333C1 1.2358 1.03792 1.14784 1.09665 1.0874L-0.33774 -0.306347C-0.764928 0.133301 -1 0.723623 -1 1.33333H1ZM1 18.6667V1.33333H-1V18.6667H1ZM1.09665 18.9126C1.03792 18.8522 1 18.7642 1 18.6667H-1C-1 19.2764 -0.764929 19.8667 -0.337738 20.3063L1.09665 18.9126ZM1.29555 19C1.22659 19 1.15444 18.9721 1.09665 18.9126L-0.337741 20.3063C0.0903987 20.747 0.677304 21 1.29555 21V19ZM15.5466 19H1.29555V21H15.5466V19ZM15.7455 18.9126C15.6877 18.9721 15.6155 19 15.5466 19V21C16.1648 21 16.7517 20.747 17.1798 20.3063L15.7455 18.9126ZM15.8421 18.6667C15.8421 18.7642 15.8042 18.8522 15.7455 18.9126L17.1798 20.3063C17.607 19.8667 17.8421 19.2764 17.8421 18.6667H15.8421Z",
    fill: "url(#paint1_linear_1966_9964)",
    mask: "url(#path-1-inside-1_1966_9964)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 9.57422L13.2533 9.57422L3.77563 9.57422Z",
    fill: "url(#paint2_linear_1966_9964)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 9.57422L13.2533 9.57422",
    stroke: "url(#paint3_linear_1966_9964)",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 14.3147L13.2533 14.3147L3.77563 14.3147Z",
    fill: "url(#paint4_linear_1966_9964)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 14.3147L13.2533 14.3147",
    stroke: "url(#paint5_linear_1966_9964)",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1966_9964",
    x1: 0,
    y1: 10,
    x2: 16.8421,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1966_9964",
    x1: 0,
    y1: 10,
    x2: 16.8421,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1966_9964",
    x1: 3.77563,
    y1: 10.0742,
    x2: 13.2533,
    y2: 10.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1966_9964",
    x1: 3.77563,
    y1: 10.0742,
    x2: 13.2533,
    y2: 10.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1966_9964",
    x1: 3.77563,
    y1: 14.8147,
    x2: 13.2533,
    y2: 14.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1966_9964",
    x1: 3.77563,
    y1: 14.8147,
    x2: 13.2533,
    y2: 14.8147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06BCC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTearSheetHoveredIcon);
export default __webpack_public_path__ + "static/media/TearSheetHoveredIcon.e85dd0638013e0ab3f2beaf1ee756d42.svg";
export { ForwardRef as ReactComponent };